import { z } from 'zod'

export const uninstallFormschema = z.object({
  imei: z.string().optional(),
  registersNumber: z
    .string()
    .nonempty({ message: 'El número de registro es obligatorio' }),
  brand: z.string().nonempty({ message: 'La marca es obligatoria' }),
  model: z.string().nonempty({ message: 'El modelo es obligatorio' })
})

export type UninstallApp = z.infer<typeof uninstallFormschema>

export const uninstallResponseSchema = uninstallFormschema.merge(
  z.object({
    hoursEnrolled: z.number()
  })
)
export type UninstallResponse = z.infer<typeof uninstallResponseSchema>

export type Uninstalled = {
  device_id: string
}
